<script>
import axios from '@/utils/axios';
import { useToast } from 'vue-toastification';

export default {
inject: ['setLoading'],  
data() {
  return {
    errors: {},
    title: "Sales",
    text: "Sales",
    text1: "Quotations",
    toast: useToast(),
    quotation: [],
    admin: [],
    banks: [],
    previewData: null
  };
},

 created() {
  this.loadPreviewData();
 },

methods: {

 loadPreviewData(){
  const previewId = this.$route.params.id;
  const storedData = sessionStorage.getItem(`preview_${previewId}`);

  if(storedData){
   this.previewData = JSON.parse(storedData);
   // Optionally remove from storage after loading
   sessionStorage.removeItem(`preview_${previewId}`);
   this.adminDetail(this.clientAdmin.id);
   this.adminBanks(this.clientAdmin.id);
  }

  console.log(this.previewData.items);

 },   

 async adminDetail(admin_id){
  try{
   const response = await axios.get(`admin/${admin_id}`);
   this.admin = response.data.data;
  }catch(error){
   console.log(error.message);
  }
 },

 async adminBanks(admin_id){
  try{
   const response = await axios.get(`banks/${admin_id}`);
   this.banks = response.data.data;
  }catch(error){
   console.log(error.message);
  }
 },

},

};
</script>

<template>
 <div class="content mt-2 mb-3">
  
  <!-- Invoices -->
<div style="width:210mm; min-height:297mm; margin:auto; padding:20px; box-sizing:border-box; border:1px solid #ccc;">

  <!-- Header -->
  <table style="width:100%; border-collapse:collapse; border:1px solid #ddd;">
    <tr>
      <th colspan="2" style="font-size:20px; font-weight:600; text-align:center; background:#444; color:#fff; padding:10px; letter-spacing:1px;"> QUOTATION</th>
    </tr>
    <tr>
      <td style="width:40%; padding:10px; border:1px solid #ddd; vertical-align:top;">
        <img :src="$clientLogo(admin.company?.logo, admin)" :alt="admin.company?.company_name" style="width:180px; height:auto; margin-bottom:6px;"><br>
      </td>
      <td style="width:60%; padding:10px; border:1px solid #ddd; text-align:right; vertical-align:top; line-height:1.5;">
        <h2 style="margin:0; font-size:18px; color:#222;">{{ admin?.company?.company_name }}</h2>
        <p v-if="admin?.company?.gst" style="margin:2px 0;">GSTIN: <strong>{{ admin?.company?.gst }}</strong></p>
        <p style="margin:2px 0;">ISO 9001:2015 CERTIFIED COMPANY</p>
        <p style="margin:2px 0;">Email: <strong>{{ admin?.company?.email }}</strong></p>
        <p style="margin:2px 0;">{{ admin?.company?.address }} {{ admin?.company?.city }}, {{ admin?.company?.state }} {{ admin?.company?.country }} - {{ admin?.company?.pincode }}</p>
        <p v-if="admin?.company?.mobile" style="margin:2px 0;">Phone: <strong>{{ admin?.company?.mobile }}</strong></p>
      </td>
    </tr>
    <tr>
      <td style="padding:10px; border:1px solid #ddd; vertical-align:top; line-height:1.5;">
        <p style="margin:2px 0;"><strong>Name:</strong> {{ previewData.to_name }}</p>
        <p style="margin:2px 0;" v-if="previewData.to_pincode"><strong>Address:</strong> {{ previewData.to_address }}, {{ previewData.to_city }}, {{ previewData.to_state }}, {{ previewData.to_country }} - {{ previewData.to_pincode }}</p>
        <p style="margin:2px 0;" v-if="previewData.to_email"><strong>Email:</strong> {{ previewData.to_email }}</p>
        <p style="margin:2px 0;" v-if="previewData.to_phone"><strong>Phone:</strong> {{ previewData.to_phone }}</p>
        <p style="margin:2px 0;" v-if="previewData.gst_no"><strong>GSTIN:</strong> {{ previewData.gst_no }}</p>
      </td>
      <td style="padding:10px; border:1px solid #ddd; vertical-align:top; line-height:1.5;">
        <p style="margin:2px 0;"><strong>Quotation No:</strong> {{ previewData.quotation_number }}</p>
        <p style="margin:2px 0;"><strong>Date:</strong> {{ $formatDate(previewData.quotation_date, 'DD MMM YYYY') }}</p>
        <p style="margin:2px 0;"><strong>Sales Person:</strong> {{ auth?.name }}</p>
        <p style="margin:2px 0;"><strong>Contact:</strong> {{ auth?.mobile }}</p>
        <p style="margin:2px 0;"><strong>Email:</strong> {{ auth?.email }}</p>
      </td>
    </tr>
    <tr>
      <td colspan="2" style="padding:10px; border:1px solid #ddd; text-align:left; line-height:1.5;">
        <p style="margin:2px 0;"><strong>Subject:</strong> {{ previewData.subject }}</p>
       <div class="dynamic"> 
        <strong>Summary:</strong>
        <div v-html="previewData.summary"></div>
       </div>
      </td>
    </tr>
  </table>

  <!-- Product Table -->
  <table style="width:100%; border-collapse:collapse; margin-top:15px;">
    <tr style="background:#f2f2f2;">
      <th style="border:1px solid #ddd; padding:6px;">S.No.</th>
      <th style="border:1px solid #ddd; padding:6px;">Title</th>
      <th style="border:1px solid #ddd; padding:6px;">Image</th>
      <th style="border:1px solid #ddd; padding:6px;">HSN/SAC</th>
      <th style="border:1px solid #ddd; padding:6px;">Price</th>
      <th style="border:1px solid #ddd; padding:6px;">Quantity</th>
      <th style="border:1px solid #ddd; padding:6px;" v-if="previewData.tax_mode === 'Item'">Tax</th>
      <th style="border:1px solid #ddd; padding:6px;">Sub Total</th>
      <th style="border:1px solid #ddd; padding:6px;">Final Amount</th>
    </tr>

    <tr v-for="(row, index) in previewData?.items" :key="index">
      <td style="border:1px solid #ddd; padding:6px; text-align:center;">{{index + 1}}</td>
      <td style="border:1px solid #ddd; padding:6px; line-height:1.4;">
        {{row.name}}
        <p v-if="row.unit" style="margin-bottom: 0;"> Unit: {{ row.unit }}</p>
        <p v-if="row.description" style="margin-bottom: 0;" v-html="row.description"></p>
      </td>
      <td style="border:1px solid #ddd; padding:6px; text-align:center;">
        <img :src="$clientImage(row.image, 'items', clientAdmin)" style="width: 80px;height: 80px;object-fit: cover;">
      </td>
      <td style="border:1px solid #ddd; padding:6px; text-align:right;">{{row.hsn_code ?? 'N/A'}}</td>
      <td style="border:1px solid #ddd; padding:6px; text-align:right;">{{row.price}}</td>
      <td style="border:1px solid #ddd; padding:6px; text-align:center;">{{row.qty}}</td>
      <td style="border:1px solid #ddd; padding:6px; text-align:right;" v-if="previewData.tax_mode === 'Item'">{{ row.taxName }}</td>
      <td style="border:1px solid #ddd; padding:6px; text-align:right;">{{row.amount}}</td>
      <td style="border:1px solid #ddd; padding:6px; text-align:right; font-weight:600;">{{ row.totalWithTax.toFixed(2) }}</td>
    </tr>
      
    <!-- Totals -->
    <tr>
      <td colspan="9" style="border:1px solid #ddd; text-align:right; padding:10px; font-size:14px; line-height:1.6;">
        Sub Total: <strong>{{ previewData.totalAmount }}</strong><br>

        {{ previewData.tax_mode === 'Invoice' ? `Tax: ${previewData.tax_name}` : 'Item Taxes' }}: <strong>{{ previewData.taxAmount }}</strong><br>

        <span v-if="previewData.discount > 0">Discount: <strong>{{ previewData.discount }}</strong><br></span>

        <span v-if="previewData.transportation_cost > 0">Transportation Cost: <strong>{{ previewData.transportation_cost }}</strong><br></span>

        <span v-if="previewData.installation_cost > 0">Installation Cost: <strong>{{ previewData.installation_cost }}</strong><br></span>
        
        <span style="font-size:15px; font-weight:600; color:#222;">Final Amount: {{ `${previewData.currency} ${previewData.grandTotal}` }}</span><br>
        ({{ $amountInWords(previewData.grandTotal) }})
      </td>
    </tr>
  </table>

  <!-- Terms -->
  <table style="width:100%; border-collapse:collapse; margin-top:15px;" v-if="previewData.terms">
    <tr>
      <td style="border:1px solid #ddd; padding:10px;">
       <h5 style="margin-bottom: 1rem;">Terms:</h5> 
       <div class="dynamic"> 
        <div v-html="previewData.terms"></div>
       </div> 
      </td>
    </tr>
  </table>

  <!-- Bank Details -->
  <table style="width:100%; border-collapse:collapse; margin-top:15px;">
    <tr>
      <th colspan="3" style="border:1px solid #ddd; padding:10px; text-align:left; background:#f2f2f2;">
        <u>BANK DETAILS</u>
      </th>
    </tr>
    <tr>

      <td style="border:1px solid #ddd; padding:10px; width:50%; vertical-align:top; line-height:1.6;" v-for="row in banks">
        <strong>{{row.name}}</strong><br>
        A/C Holder: {{row.account_holder_name}}<br>
        A/C No: {{row.account_no}}<br>
        IFSC: {{row.ifsc}}<br>
        Branch: {{row.branch}}<br>
        <img :src="$clientImage(row.image, 'banks', admin)" width="100" />
      </td>
    </tr>
  </table>

<div style="display:flex;justify-content: space-around;margin-top:25px;" class="dynamic">
<div style="width:70%">
 <h5 style="margin-bottom: 1rem;" v-if="previewData.notes">Notes:</h5> 
   <div v-html="previewData.notes"></div>
</div>
<div style="width:30%">  
  <!-- Signature -->
  <div style="text-align:right; line-height:1.6;">
    <img :src="$clientSignature(admin.company?.signature, admin)" style="width:120px; height:auto; margin-bottom:5px;"><br>
    <strong style="font-size:15px;">Authorised Signatory</strong><br>
    <span>On behalf of {{admin.company?.company_name}}</span>
  </div>
</div>
</div>


</div>
  <!-- /Invoices -->

    <!-- <div class="d-flex justify-content-center align-items-center mb-4">
      <a href="javascript:void(0);" class="btn btn-primary d-flex justify-content-center align-items-center me-2"><i class="ti ti-printer me-2"></i>Print Invoice</a>
      <a href="javascript:void(0);" class="btn btn-white d-flex justify-content-center align-items-center border"><i class="ti ti-copy me-2"></i>Clone Invoice</a>
    </div> -->
  </div>


</template>
